import { DatePickerWithRange } from "@/components/ui/date-picker-with-range";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import type { TimeGranularity } from "@/lib/ledger/dashboard-analytics";
import type { DateRange } from "react-day-picker";

interface DashboardFiltersProps {
  dateRange: DateRange | null;
  onDateRangeChange: (range: DateRange | null) => void;
  granularity?: TimeGranularity;
  onGranularityChange?: (granularity: TimeGranularity) => void;
  accountSelector?: React.ReactNode;
}

export function DashboardFilters({
  dateRange,
  onDateRangeChange,
  granularity,
  onGranularityChange,
  accountSelector,
}: DashboardFiltersProps) {
  const showGranularity =
    granularity !== undefined && onGranularityChange !== undefined;
  const gridCols = accountSelector
    ? showGranularity
      ? "md:grid-cols-3"
      : "md:grid-cols-2"
    : showGranularity
      ? "md:grid-cols-2"
      : "md:grid-cols-1";

  return (
    <div className="flex flex-col gap-4">
      <div className={`grid grid-cols-1 ${gridCols} gap-4`}>
        {accountSelector && (
          <div className="flex flex-col gap-2">
            <Label>Konto</Label>
            {accountSelector}
          </div>
        )}
        <div className="flex flex-col gap-2">
          <Label>Zeitraum</Label>
          <DatePickerWithRange
            value={
              dateRange?.from && dateRange?.to
                ? { from: dateRange.from, to: dateRange.to }
                : undefined
            }
            onChange={onDateRangeChange}
            placeholder="Zeitraum auswählen"
          />
        </div>

        {showGranularity && (
          <div className="flex flex-col gap-2">
            <Label>Auflösung</Label>
            <RadioGroup
              value={granularity}
              onValueChange={(value) =>
                onGranularityChange?.(value as TimeGranularity)
              }
              className="flex gap-4"
            >
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="daily" id="daily" />
                <Label htmlFor="daily" className="font-normal cursor-pointer">
                  Täglich
                </Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="weekly" id="weekly" />
                <Label htmlFor="weekly" className="font-normal cursor-pointer">
                  Wöchentlich
                </Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="monthly" id="monthly" />
                <Label htmlFor="monthly" className="font-normal cursor-pointer">
                  Monatlich
                </Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="quarterly" id="quarterly" />
                <Label
                  htmlFor="quarterly"
                  className="font-normal cursor-pointer"
                >
                  Quartalsweise
                </Label>
              </div>
            </RadioGroup>
          </div>
        )}
      </div>
    </div>
  );
}
